
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPurposeReasonDialog extends Serenity.EntityDialog<PsPurposeReasonRow, any> {
        protected getFormKey() { return PsPurposeReasonForm.formKey; }
        protected getIdProperty() { return PsPurposeReasonRow.idProperty; }
        protected getLocalTextPrefix() { return PsPurposeReasonRow.localTextPrefix; }
        protected getNameProperty() { return PsPurposeReasonRow.nameProperty; }
        protected getService() { return PsPurposeReasonService.baseUrl; }
        protected getDeletePermission() { return PsPurposeReasonRow.deletePermission; }
        protected getInsertPermission() { return PsPurposeReasonRow.insertPermission; }
        protected getUpdatePermission() { return PsPurposeReasonRow.updatePermission; }

        protected form = new PsPurposeReasonForm(this.idPrefix);

    }
}